export default __webpack_public_path__ + "static/media/shutterstock_666769963.4306aaaf.png";